import React from 'react';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';
import { type IconV2Props } from '../../IconV2';

const GoogleOutlined32: React.FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.googleFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.84 1.44c7.947 0 14.4 6.453 14.4 14.4s-6.453 14.4-14.4 14.4-14.4-6.453-14.4-14.4 6.453-14.4 14.4-14.4zm0 1.5c-7.119 0-12.9 5.781-12.9 12.9 0 7.119 5.781 12.9 12.9 12.9 7.119 0 12.9-5.781 12.9-12.9 0-7.119-5.781-12.9-12.9-12.9zm.313 7.265c1.503 0 2.78.518 3.783 1.374l.197.175-1.706 1.706c-.617-.59-1.4-.89-2.274-.89-1.55 0-2.86 1.047-3.328 2.453a3.575 3.575 0 00-.187 1.13c0 .392.068.773.187 1.13.468 1.406 1.779 2.452 3.328 2.452.711 0 1.329-.166 1.831-.454l.183-.113.167-.12c.483-.376.821-.885.976-1.476l.044-.2h-3.201v-2.3h5.602c.07.389.108.794.108 1.216 0 1.812-.649 3.336-1.774 4.372-.984.908-2.33 1.44-3.936 1.44a5.944 5.944 0 01-5.206-3.07l-.11-.206-.127-.271a5.943 5.943 0 010-4.8l.128-.271.109-.206a5.944 5.944 0 015.206-3.07z"
      fillRule="evenodd"
    />
  </svg>
);

export default GoogleOutlined32;
